<template>
    <div class="location-page">
        <!-- Background Grid Pattern -->
        <div class="grid-background"></div>
        
        <div class="location-container">
            <!-- Header -->
            <div class="location-header">
                <div class="location-logo">
                    <img src="../../../assets/img/logo.png" alt="logo" class="logo-img" />
                </div>
                <h1 class="location-title">Welcome</h1>
                <p class="location-subtitle">Inventory Management System</p>
            </div>

            <!-- Location Cards -->
            <div class="location-cards-grid">
                <div class="location-card blue" @click="selectLocation('Coimbatore')">
                    <div class="card-icon-wrapper">
                        <div class="card-icon">
                            <i class="fas fa-camera"></i>
                        </div>
                    </div>
                    <h3 class="card-title">Coimbatore</h3>
                    <p class="card-description">Coimbatore Branch Location</p>
                    <button class="card-button">Login</button>
                </div>

                <div class="location-card green" @click="selectLocation('Management')">
                    <div class="card-icon-wrapper">
                        <div class="card-icon">
                            <i class="fas fa-cog"></i>
                        </div>
                    </div>
                    <h3 class="card-title">Management</h3>
                    <p class="card-description">Management Portal</p>
                    <button class="card-button">Login</button>
                </div>

                <div class="location-card purple" @click="selectLocation('Mangalore')">
                    <div class="card-icon-wrapper">
                        <div class="card-icon">
                            <i class="fas fa-map-marker-alt"></i>
                        </div>
                    </div>
                    <h3 class="card-title">Mangalore</h3>
                    <p class="card-description">Mangalore Branch Location</p>
                    <button class="card-button">Login</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LocationSelect',
    data() {
        return {
            selectedLocation: null,
        };
    },
    methods: {
        selectLocation(location) {
            // Store the selected location in localStorage
            localStorage.setItem('selectedLocation', location);
            // Store in Vuex store if needed
            this.$store.commit('setSelectedLocation', location);
            // Navigate to signin
            this.$router.push({ name: 'signin' });
        },
    },
    created() {
        // If already authenticated, redirect to index
        if (this.$store.getters.isAuthenticated) {
            this.$router.push({ name: 'index' });
        }
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.location-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #0f172a 0%, #1e40af 25%, #3b82f6 50%, #1e40af 75%, #0f172a 100%);
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

/* Grid Background Pattern */
.grid-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
        linear-gradient(rgba(0, 0, 0, 0.08) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 0, 0, 0.08) 1px, transparent 1px);
    background-size: 50px 50px;
    pointer-events: none;
    z-index: 0;
}

.location-container {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: 1200px;
    padding: 40px 20px;
    text-align: center;
}

.location-header {
    margin-bottom: 60px;
    animation: fadeInDown 0.8s ease;
}

.location-logo {
    margin-bottom: 30px;
    animation: logoFloat 3s ease-in-out infinite;
}

.logo-img {
    max-width: 120px;
    height: auto;
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.25));
}

.location-title {
    font-size: 48px;
    font-weight: 700;
    color: white;
    margin-bottom: 12px;
    letter-spacing: -1px;
    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.location-subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 300;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.location-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
    margin-top: 40px;
    justify-items: center;
}

.location-card {
    width: 100%;
    max-width: 320px;
    padding: 40px 30px;
    border-radius: 20px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    background: rgba(50, 30, 15, 0.8);
    backdrop-filter: blur(10px);
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    text-decoration: none;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
}

.location-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
    pointer-events: none;
    border-radius: 20px;
}

.location-card:hover {
    transform: translateY(-15px) scale(1.02);
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(50, 30, 15, 0.9);
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* Blue Card - Coimbatore */
.location-card.blue .card-icon-wrapper {
    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
}

.location-card.blue:hover {
    border-color: rgba(39, 174, 96, 0.5);
    background: rgba(39, 174, 96, 0.1);
}

.location-card.blue .card-button {
    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
}

.location-card.blue .card-button:hover {
    box-shadow: 0 10px 25px rgba(39, 174, 96, 0.4);
}

/* Green Card - Mangalore */
.location-card.green .card-icon-wrapper {
    background: linear-gradient(135deg, #00d4ff 0%, #0099cc 100%);
}

.location-card.green:hover {
    border-color: rgba(0, 212, 255, 0.5);
    background: rgba(0, 212, 255, 0.1);
}

.location-card.green .card-button {
    background: linear-gradient(135deg, #00d4ff 0%, #0099cc 100%);
}

.location-card.green .card-button:hover {
    box-shadow: 0 10px 25px rgba(0, 212, 255, 0.4);
}

/* Purple Card - Management */
.location-card.purple .card-icon-wrapper {
    background: linear-gradient(135deg, #d946ef 0%, #a21caf 100%);
}

.location-card.purple:hover {
    border-color: rgba(217, 70, 239, 0.5);
    background: rgba(217, 70, 239, 0.1);
}

.location-card.purple .card-button {
    background: linear-gradient(135deg, #d946ef 0%, #a21caf 100%);
}

.location-card.purple .card-button:hover {
    box-shadow: 0 10px 25px rgba(217, 70, 239, 0.4);
}

.card-icon-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    transition: all 0.4s ease;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

.location-card:hover .card-icon-wrapper {
    transform: scale(1.1) rotate(5deg);
}

.card-icon {
    font-size: 40px;
    color: white;
}

.card-title {
    font-size: 24px;
    font-weight: 700;
    color: white;
    margin-bottom: 10px;
    position: relative;
    z-index: 1;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.card-description {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 28px;
    position: relative;
    z-index: 1;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-button {
    width: 100%;
    padding: 14px 24px;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 1px;
    position: relative;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.card-button:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.card-button:active {
    transform: scale(0.97);
}

/* Animations */
@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
 

@keyframes logoFloat {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-10px);
    }
}       opacity: 1;
        transform: translateY(0);
    }
}

.location-card {
    animation: fadeInUp 0.8s ease;
    animation-fill-mode: both;
}

.location-card:nth-child(1) {
    animation-delay: 0.2s;
}

.location-card:nth-child(2) {
    animation-delay: 0.4s;
}

.location-card:nth-child(3) {
    animation-delay: 0.6s;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .location-page {
        padding: 20px;
    }

    .location-title {
        font-size: 36px;
    }

    .location-subtitle {
        font-size: 16px;
    }

    .location-cards-grid {
        grid-template-columns: 1fr;
        gap: 24px;
    }

    .location-card {
        max-width: 100%;
    }

    .logo-img {
        max-width: 100px;
    }

    .card-title {
        font-size: 20px;
    }

    .card-description {
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .location-header {
        margin-bottom: 40px;
    }

    .location-title {
        font-size: 28px;
    }

    .location-subtitle {
        font-size: 14px;
    }

    .location-card {
        padding: 30px 20px;
    }

    .card-icon-wrapper {
        width: 70px;
        height: 70px;
    }

    .card-icon {
        font-size: 32px;
    }
}
</style>
